<template>
  <!-- Main container for the banner products page -->
  <v-row align="center" justify="center" v-if="loading">
    <v-progress-circular indeterminate color="primary"></v-progress-circular>
  </v-row>

  <div class="grid-container" v-else>
    <!-- Vuetify Loading Component -->

    <!-- Content to display when not loading -->
    <div>
      <!-- Displaying all products associated with the banner -->
      <v-col> <Breadcrumbs :items="breadcrumbItems" /></v-col>
      <v-col>
        <p class="bold-h1">{{ $t("most_common_items") }}</p>
        <v-row align="center" justify="center" class="mt-10"> </v-row>
        <AllProducts :products="products" :hideLoadMore="true" />
      </v-col>
    </div>
  </div>
</template>

<script>
import { ref, watch, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import UserAPI from "@/api/UserAPI";
import { useI18n } from "vue-i18n";
import AllProducts from "@/components/AllProducts.vue";
import { mapState } from "vuex";
import { useHead } from "@unhead/vue";
import Breadcrumbs from "../components/Breadcrumbs.vue";
/**
 * BannerProducts component.
 * Displays products associated with a specific banner.
 *
 * @component
 */
export default {
  name: "BannerProducts",
  components: {
    AllProducts,
    Breadcrumbs,
  },
  data() {
    return {
      loading: true,
      products: [],
    };
  },
  watch: {
    currentLang(newVal) {
      this.commonItems();
    },
  },
  setup() {
    const { t, locale } = useI18n();
    return { t, locale };
  },
  computed: {
    ...mapState(["currentLang", "categories"]),
    breadcrumbItems() {
      // Initialize breadcrumbs with the home page
      let items = [
        {
          text: this.t("home"),
          to: {
            name: "handla",
          },
        },

        {
          text: this.t("saved"),
          to: {
            name: "saved",
          },
        },

        {
          text: this.t("most_common_items"),
          disabled: true,
        },
      ];
      return items;
    },
  },
  methods: {
    async commonItems() {
      const data = await UserAPI.getMostCommon(1, 50);

      this.setHead();
      this.products = data || [];
    },
    setHead() {
      const bannerTitle = `Dina vanligaste varor - NearbyStore`;

      useHead({
        title: bannerTitle,
        meta: [
          {
            property: "og:url",
            content: window.location.href, // Automatically use current page URL
          },
          {
            property: "og:title",
            content: "Dina vanligaste varor", // Ensure Open Graph title matches
          },
          {
            hid: "description",
            name: "description",
            content:
              "Beställ idag på NearbyStore och få din mat levererad samma dag. Upptäck ett brett sortiment av färska råvaror och livsmedel, med bekväm hämtning nära dig. Shoppa enkelt och snabbt!",
          },
        ],
        __key: "bannerDetailHead",
      });
    },
  },
  async activated() {
    this.loading = true;
    await this.commonItems();
    this.loading = false;
  },
};
</script>

<style scoped>
/* Style for breadcrumbs container */
.breadcrumbs {
  max-width: 1300px;
  margin: auto;
  padding-left: 20px;
}

/* Style for the main grid container */
.grid-container {
  width: 100%;
  margin-bottom: 125px;
  position: relative;
}
</style>
